import { faker } from '@faker-js/faker';
import { sample } from 'lodash';

// ----------------------------------------------------------------------

const partie = [...Array(24)].map((_, index) => ({
  id: faker.datatype.uuid(),
  contactPerson: faker.name.fullName(),
  mail: faker.internet.email(),
  phone: faker.phone.number('+421 91# ### ###'),
}));

export default partie;
